{
  "refinement.intake.acceptAll": "Review all",
  "refinement.intake.acceptSelected": "Review selected ({{count}})",
  "refinement.intake.applied": "Applied {{count}} result(s)",
  "refinement.intake.back": "Back",
  "refinement.intake.cancel": "Cancel",
  "refinement.intake.classification.automation": "Automation draft",
  "refinement.intake.classification.linked_project_area": "Linked project area",
  "refinement.intake.classification.rationale": "Rationale",
  "refinement.intake.clearMatch": "Do not use this match",
  "refinement.intake.clarify": "Clarify",
  "refinement.intake.confidence": "{{value}}% confidence",
  "refinement.intake.confirmApply": "Apply these changes",
  "refinement.intake.createSplit": "Create revised triage",
  "refinement.intake.deadline": "deadline",
  "refinement.intake.edit": "Edit",
  "refinement.intake.editTitle": "Proposed title",
  "refinement.intake.error.generic": "This action could not be completed. Your review choices are still here.",
  "refinement.intake.exactChanges": "Exact changes",
  "refinement.intake.intentState.accepted": "Applied",
  "refinement.intake.intentState.pending": "Pending",
  "refinement.intake.intentState.rejected": "Rejected",
  "refinement.intake.keyboardHelp": "Keyboard: J/K moves between proposals, Space selects, A reviews all, and R rejects the active proposal.",
  "refinement.intake.lede": "Review what Exognitos understood. Nothing becomes real until you confirm the exact changes.",
  "refinement.intake.link": "Link",
  "refinement.intake.linked": "linked",
  "refinement.intake.loadError": "This triage could not be loaded",
  "refinement.intake.matches": "Possible existing matches",
  "refinement.intake.merge": "Merge",
  "refinement.intake.noEffects": "No changes were described.",
  "refinement.intake.noExtraAuthority": "No additional authority",
  "refinement.intake.noTiming": "No exact date or time will be added.",
  "refinement.intake.openResult": "Open result",
  "refinement.intake.optional": "Optional",
  "refinement.intake.previewDescription": "{{intents}} proposal(s), {{effects}} exact effect(s). This preview has written nothing.",
  "refinement.intake.previewTitle": "Ready to apply",
  "refinement.intake.proposals": "Proposals",
  "refinement.intake.proposalsDescription": "Each proposal can be edited, matched, accepted, or rejected independently.",
  "refinement.intake.questions": "Clarification needed",
  "refinement.intake.questionsDescription": "Answer only what you know. Ambiguous dates and low-confidence interpretations stay uncommitted.",
  "refinement.intake.receipt": "Receipt",
  "refinement.intake.receiptDescription": "{{count}} result(s) applied on {{date}}.",
  "refinement.intake.recurring": "recurring",
  "refinement.intake.refresh": "Load latest revision",
  "refinement.intake.reject": "Reject",
  "refinement.intake.reminder": "{{count}} min reminder",
  "refinement.intake.retry.answers": "Retry answers",
  "refinement.intake.retry.apply": "Retry apply",
  "refinement.intake.retry.edit": "Retry edit",
  "refinement.intake.retry.preview": "Retry preview",
  "refinement.intake.retry.reject": "Retry reject",
  "refinement.intake.retry.resolution": "Retry match",
  "refinement.intake.retry.split": "Retry split",
  "refinement.intake.retry.undo": "Retry undo",
  "refinement.intake.revision": "rev. {{value}}",
  "refinement.intake.save": "Save",
  "refinement.intake.saveAnswers": "Save answers",
  "refinement.intake.scheduled": "scheduled",
  "refinement.intake.selectAll": "Select every pending proposal",
  "refinement.intake.selectIntent": "Select {{title}}",
  "refinement.intake.split": "Split",
  "refinement.intake.splitDisabled": "Split before applying or rejecting any proposal.",
  "refinement.intake.splitHint": "Put each separate thought on its own line. A new triage will replace this draft; applied work is never duplicated.",
  "refinement.intake.splitLabel": "Separate thoughts",
  "refinement.intake.status.applied": "Applied",
  "refinement.intake.status.draft": "Ready to review",
  "refinement.intake.status.expired": "Expired",
  "refinement.intake.status.needsInput": "Needs clarification",
  "refinement.intake.status.partiallyApplied": "Partially applied",
  "refinement.intake.status.rejected": "Rejected",
  "refinement.intake.status.superseded": "Replaced by a newer triage",
  "refinement.intake.timing": "Date, time, and recurrence",
  "refinement.intake.title": "Triage",
  "refinement.intake.undo": "Undo safely",
  "refinement.intake.undone": "This application was safely moved to Trash.",
  "refinement.intake.quick.description": "Review a structured proposal before anything becomes a Task, Project, Note, or schedule.",
  "refinement.intake.quick.sort": "Sort for me",
  "refinement.intake.quick.sorted": "Your triage is ready"
}
